// import { Utils } from '@/helper'
// import * as types from '@/store/mutation-types'
// import AuthService from '@/services/auth'

const state = {
  // user: Utils.parseJSON(Storage.get('user')),
  secret_code: '',
  register_role: null,
  token: null,
  hmac: null,
  pendingUser: null,
  user: null,
  genreIds: '',
  firstVisit: false,
  redirectPath: '',
}

const getters = {
  isAuthenticated: (state) => {
    return state.token != null
  },
  userType: (state) => {
    return state.user && state.user.user_type
  },
  currentUser: (state) => {
    return state.user
  },
  redirectPath: (state) => {
    return state.redirectPath
  },
}

const actions = {
  setToken({ commit }, token) {
    commit('setToken', token)
  },

  setHMAC({ commit }, hmac) {
    commit('setHMAC', hmac)
  },

  setUser({ commit }, user) {
    commit('setUser', user)
  },

  setStripeStatus({ commit }, status) {
    commit('setStripeStatus', status)
  },

  setPendingUser({ commit }, user) {
    commit('setPendingUser', user)
  },

  setStream({ commit }, stream) {
    commit('setStream', stream)
  },

  addFavoriteUser({ commit }, user) {
    commit('addFavoriteUser', user)
  },

  removeFavoriteUser({ commit }, user) {
    commit('removeFavoriteUser', user)
  },

  setRegisterRole({ commit }, role) {
    commit('setRegisterRole', role)
  },

  setSecretCode({ commit }, code) {
    commit('setSecretCode', code)
  },

  setGenreIds({ commit }, genreIds) {
    commit('setGenreIds', genreIds)
  },

  setFirstVisit({ commit }, firstVisit) {
    commit('setFirstVisit', firstVisit)
  },

  setRedirectPath({ commit }, path) {
    commit('setRedirectPath', path)
  },
}

const mutations = {
  setToken(state, token) {
    state.token = token
  },

  setHMAC(state, hmac) {
    state.hmac = hmac
  },

  setUser(state, user) {
    // console.log('setUser', user)
    state.user = user
  },

  setPendingUser(state, user) {
    state.pendingUser = user
  },

  setStream(state, stream) {
    state.user.stream = stream
  },

  setStripeStatus(state, status) {
    state.user.stripe_connected = status
  },

  addFavoriteUser(state, user) {
    state.user.favorite_users.push(user)
  },

  removeFavoriteUser(state, user) {
    for (let index in state.user.favorite_users) {
      if (user.id === state.user.favorite_users[index].id) {
        state.user.favorite_users.splice(index, 1)
        break
      }
    }
  },

  setRegisterRole(state, role) {
    state.register_role = role
  },

  setSecretCode(state, code) {
    state.secret_code = code
  },

  setGenreIds(state, genreIds) {
    state.genreIds = genreIds
  },

  setFirstVisit(state, firstVisit) {
    state.firstVisit = firstVisit
  },

  setRedirectPath(state, path) {
    state.redirectPath = path
  },
}

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js